import React, { useContext, useEffect, useState } from "react";
import './abmLegajos.css';
import * as XLSX from 'xlsx';
import { createEstructuraABMLegajo, createEstructuraLegajo } from "../../utils/estructuras";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faBackspace} from "@fortawesome/free-solid-svg-icons";
import { useRef } from "react";
import productsContext from "../../context/productos/productsContext";
import Swal from 'sweetalert2';
import categoriasRRHHContext from "../../context/categoriasRRHHContext/categoriasRRHHContex";
import legajoContext from "../../context/legajoContext/legajoContex";
import Select from 'react-select';


const AbmLegajos = ({setShowAbm = () => console.log('Cerrar'), legajoToEdit = {}, setLegajoToEdit = () => console.log('Set product to edit')}) => {
    const [legajoEditing,setLegajoEditing] = useState(legajoToEdit);
    const [legajosData,setLegajosData] = useState([createEstructuraABMLegajo()]);
    const [categoriasError,setCategoriasError] = useState([]);
    const fileInputRef = useRef(null);

    const ctContext = useContext(categoriasRRHHContext);
    const {categoriasRRHHList} = ctContext;

    const lContext = useContext(legajoContext);
    const {legajosList,agregarLegajo,modificarLegajo,actualizarLegajosList,eliminarLegajo} = lContext;

    const categoriasOptions = Array.isArray(categoriasRRHHList) && categoriasRRHHList.length > 0 ? categoriasRRHHList.map((c,i) => ({value:c.codigo,label:c.descrp})) : []; 

    const handleChange = (e, i = -1, catego = {}) =>{
        if(Object.keys(legajoEditing).length > 0){
            if(Object.keys(catego).length > 0){
                let categoriaFound = categoriasRRHHList.find(c => c.codigo == catego.value);
                setLegajoEditing({...legajoEditing, catego: catego, categoriaID: categoriaFound._id})
            }else{
                const {name,value} = e.target;
                setLegajoEditing({...legajoEditing, [name]: value});
            }
        }else{
            setLegajosData((prevData) => {
                let newLegajos = prevData.slice();
                if(Object.keys(catego).length > 0){
                    let categoriaFound = categoriasRRHHList.find(c => c.codigo == catego.value);
                    newLegajos[i].catego = catego;
                    newLegajos[i].categoriaID = categoriaFound._id
                }else{
                    const {name,value} = e.target;
                    if(value != ''){
                        if(newLegajos[i].codigo != '' && newLegajos[i].nombre != ''){
                            newLegajos[i][name] = value;
                        }else{
                            newLegajos[i][name] = value;
                            newLegajos.length == i+1 && newLegajos.push(createEstructuraLegajo());
                        }
                    }else{
                        newLegajos[i][name] = value;
                        if(newLegajos[i].codigo == '' && newLegajos[i].nombre == '' ){
                            newLegajos.splice(i,1);
                        }
                    }
                }
                return newLegajos;
            })
        }

    }

    const handleFile = (file) => {
        if(file){
            const reader = new FileReader();
            reader.onload = (evt) => {
                const binaryString = evt.target.result;
                const wb = XLSX.read(binaryString, {type: 'binary'});
                const sheet = wb.Sheets[wb.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(sheet,{header:1});

                const categoriasConError = [];

                let dataModelated = jsonData.filter((l,i) => (i > 0 && l.length > 0)).map((l,i) => {
                    let objectModelated;
                    l.forEach((value,index) => {
                        switch(index){
                            case 0: 
                                objectModelated = {codigo: value};
                                break;
                            case 1:
                                objectModelated = {...objectModelated, nombre: value};
                                break;
                            case 2: 
                                let categoriaFound = categoriasRRHHList.find((c) => c.codigo == value);
                                if(!categoriaFound){
                                    categoriasConError.push(value);
                                    objectModelated = {...objectModelated, catego:{value: false, label:'No cargada en XertuX'}};
                                }else{
                                    objectModelated = {...objectModelated, categoriaID: categoriaFound._id, catego:{value: value, label:categoriaFound.descrp}};
                                }
                                break;
                        }
                        objectModelated = {...objectModelated, origen:'M'};
                    })
                    return objectModelated
                });
                if(categoriasConError.length > 0) setCategoriasError(categoriasConError);
                if(legajosData.length > 0){
                    setLegajosData((prevLegajos) => {
                        let newLegajos = [...dataModelated];
                        newLegajos = [...newLegajos, ...prevLegajos.filter(l => !dataModelated.some((lD) => lD.codigo == l.codigo || lD.nombre == l.nombre))];
                        return newLegajos
                    });
                }else{
                    setLegajosData([...dataModelated]);
                }
            }
            reader.readAsBinaryString(file);
        }
    }

    const handleChangeFile = (e) => {
        const file = e.target.files[0];
        handleFile(file);
    }

    const handleDelete = (prod,i) => {
        if(prod.codigo != ''){
            setLegajosData((prevData) => {
                let newData = prevData.filter((p,index) => index != i);
                return newData;
            })
        }
    }

    const handleSave = async() => {
        if(Object.keys(legajoEditing).length > 0){
            let legajoModelated = {...legajoEditing, catego: legajoEditing.catego.value};
            let res = await modificarLegajo(legajoModelated);
            if(res){
                Swal.fire({
                    title:'Éxito!',
                    text:'Legajo actualizado correctamente',
                    icon:'success'
                })
            }
        }else{
            if(legajosData.some((l,i) => i < legajosData.length - 1 && (l.codigo == '' || l.nombre == '' || l.catego.value == false))){
                let result = await Swal.fire({
                    title: `Ops!`,
                    icon: 'warning',
                    text: 'Ciertos legajos estan sin completar o su categoria no esta cargada en sistema, desea omitirlos y guardar igual?',
                    showConfirmButton: true,
                    showCancelButton: true, // Habilita el botón de cancelar
                    confirmButtonColor: '#ff0000',
                    denyButtonColor: '#3d4d87',
                    confirmButtonText: 'Sí, estoy seguro',
                    cancelButtonText:'No',
                    allowEnterKey: true
                })
                if (result.isConfirmed ) {
                }else{
                    return false;
                }
            }
            let legajosCompleted = legajosData.filter((l) => l.codigo != '' && l.nombre != '' &&  l.catego.value != '' && l.catego.value != false);
            
            legajosCompleted = legajosCompleted.map((l) => ({...l,catego:l.catego.value}));
            let counterSaved = 0;
            let counterFail = 0;
            for(const p of legajosCompleted){
                try {
                    let res = await agregarLegajo(p);
                    if(res == null) throw new Error("Clave Duplicada para el Legajo " + p.codigo);
                    counterSaved++;
                } catch (error) {
                    console.log("error intentando guardar el nuevo producto " + p.tipPro + ' ' +p.artCod);
                    console.log(error);
                    counterFail++;
                }
            }
            actualizarLegajosList();
            Swal.fire({
                title:'Contador',
                icon: counterFail == 0 && counterSaved > 0 ? 'success' : counterFail > 0 && counterSaved == 0 ? 'error' : 'warning',
                html: `Productos guardados con Éxito: ${counterSaved}. <br>
                Productos imposibles de guardarlos: ${counterFail}`,
            })
        }
        handleClose();
    }

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFile = e.dataTransfer.files[0];
        handleFile(droppedFile);
    }

    const handleClose = () => {
        if(Object.keys(legajoToEdit).length > 0){
            setLegajoEditing({});
            setLegajoToEdit({});
        }
        setShowAbm(false)
    }

    const handleDownloadTemplateXLSX = async() => {

    }

    useEffect(()=>{
        if(Object.keys(legajoToEdit).length > 0){
            let categoriaFound = categoriasRRHHList.find((c) => c._id == legajoToEdit.categoriaID);
            let legajoModelated = {...legajoToEdit, catego:{value:categoriaFound.codigo, label: categoriaFound.descrp}};
            setLegajoEditing(legajoModelated);
        }
    },[legajoToEdit])

    return <div className="abmLegajosModal">
        <div className="abmProductsDiv">
            <button className="minimizarBtn" onClick={handleClose}>X</button>
            <h2>{Object.keys(legajoEditing).length == 0 ? 'Alta de Legajo' : 'Edición de Legajo'}</h2>
            <div className="legajosLeidosSubtabla">
                <div className={`${Object.keys(legajoEditing).length == 0 ? '' : 'fiveColumns'} labelsSubtablas`}>
                    {Object.keys(legajoEditing).length == 0 && <label></label>}
                    <label>Codigo</label>
                    <label>Nombre</label>
                    <label>Categoria</label>
                </div>
                {Object.keys(legajoEditing).length > 0 
                ? 
                <div className={`${Object.keys(legajoEditing).length == 0 ? '' : 'fiveColumns'} legajoLoaded`}>
                    <input name="codigo" onChange={(e)=>handleChange(e)} value={legajoEditing.codigo}></input>
                    <input name="nombre" onChange={(e)=>handleChange(e)} value={legajoEditing.nombre}></input>
                    <Select
                        styles={{
                            input: (base) => ({
                                ...base,
                                width: "100%",
                                padding: ".4rem",
                                borderRadius: ".5rem",
                                fontSize: "1rem",
                                transition: "border-color .5s",
                            }),
                        }}
                        placeholder="Elija unidad de medida..."
                        options={categoriasOptions}
                        className='select'
                        value={legajoEditing.catego}
                        onChange={(selectedOption) => handleChange({},-1,selectedOption)}
                    />
                </div> 
                : 
                legajosData.map((c,i) => <div className="legajoLoaded" key={i}>
                    <FontAwesomeIcon className="iconDelete" icon={faBackspace} color="red" onClick={(e)=>handleDelete(c,i)}/>
                    <input name="codigo" onChange={(e)=>handleChange(e,i)} value={c.codigo}></input>
                    <input name="nombre" onChange={(e)=>handleChange(e,i)} value={c.nombre}></input>
                    <Select
                        styles={{
                            input: (base) => ({
                                ...base,
                                width: "100%",
                                padding: ".4rem",
                                borderRadius: ".5rem",
                                fontSize: "1rem",
                                transition: "border-color .5s"
                            })
                        }}
                        placeholder="Elija categoria"
                        options={categoriasOptions}
                        className='select'
                        value={c.catego}
                        onChange={(selectedOption) => handleChange({},i,selectedOption)}
                    />
                </div>)}
            </div>
            {Object.keys(legajoEditing).length == 0 && <a href="/templateLegajo.xlsx" download>Descargar template.xlsx</a>}
            {Object.keys(legajoEditing).length == 0 && <div className="inputFileXlsx dropNivel1" 
                onClick={() => fileInputRef.current.click()}
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}
            >
                <span  accept=".xlsx,.xls" htmlFor='excelFile'>O cargue los productos arrastrando un archivo .xlsx a esta sección</span>
                <input ref={fileInputRef} type="file" id="excelFile" style={{display:'none'}} onChange={(e)=>handleChangeFile(e)} />
            </div>}
            <button className="saveBtn" onClick={handleSave}>Guardar</button>
        </div>
    </div>
}

export default AbmLegajos;